import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import { fetchDisclaimersReducer } from './disclaimer'
import { appSettingsReducer } from './appSettings'
import { narrativeReducer } from './narrative'

const reducers = combineReducers({
  routing: routerReducer,
  appSettings: appSettingsReducer,
  narrative: narrativeReducer,
  disclaimers: fetchDisclaimersReducer,
})

export default reducers
